import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopy from '@material-ui/icons/FileCopy';
import RestartIcon from '@material-ui/icons/Replay';
import InfoIcon from '@material-ui/icons/Info';
import {isViewerUser, showError} from '../../helpers';
import {NavLink} from 'react-router-dom';
import AppActions from '../../actions/app-actions';

function VcamsExpanded (props) {
  const { info = {} } = props;
  const { error = {}, restartCount = 0 } = info;
  const clients = info.clients || [];
  const isPrimary = props.type !== undefined && props.type === 'primary';

  function staticText (label, value, cmd, onClick) {
    return (
      <div>
        <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={!cmd}>
          <ListItemText primary={label} secondary={value || '-'} />
          {
            cmd === 'copy'
              ? (
                <Tooltip title='Copy To Clipboard'>
                  <IconButton color='primary' style={{ opacity: 1 }} onClick={() => copy(value)}><FileCopy /></IconButton>
                </Tooltip>
              )
              : null
          }
          {
            cmd === 'info' && value
              ? (<IconButton color='primary' style={{ opacity: 1 }} onClick={() => onClick(props)}><InfoIcon /></IconButton>)
              : null
          }
        </ListItem>
        <Divider />
      </div>
    );
  }

  function displayProfile () {
    const { cameraAnalyzeRtspPreferred = '', cameraRtspChannels = [] } = props;
    if(cameraRtspChannels !== null) {
      const profileDetail = cameraRtspChannels.find(profile => profile.profileName === cameraAnalyzeRtspPreferred) || {};
      return (
        <>
          {staticText('Profile Name', profileDetail.profileName)}
          {staticText('Codec', profileDetail.codec)}
          {staticText('Resolution', profileDetail.resolution)}
          {staticText('Fps', profileDetail.fps)}
        </>
      );
    }
    else
      return null;
  }

  function r1Action () {
    const buttonsData = [
      {
        name: 'Deploy', openDialog: () => props.onDeploy(props), isDisplayed: () => true
      },
      {
        name: 'Duplicate', openDialog: () => props.onDuplicate(props),
        isDisplayed: () => props.one2mStatus === true && props.type === 'primary'
      },
      {
        name: 'Remove', openDialog: () => props.onRemove(props),
        isDisplayed: () => props.one2mStatus === true && props.type === 'secondary'
      }
    ];
    const button = (data, index) => (
      <Button key={index} color="primary" variant="contained" style={{marginLeft: 10}} onClick={() => data.openDialog()}>
        {data.name}
      </Button>
    );
    return (
      <Grid item xs={12}>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <Tooltip title='Restart'>
            <IconButton color='primary' onClick={() => props.onRestart(props)}><RestartIcon /></IconButton>
          </Tooltip>
          <Box>
            {buttonsData.map((data, index) => data.isDisplayed() ? button(data, index) : null)}
          </Box>
        </Box>
      </Grid>
    );
  }

  function getLinkStaticText(label, value, link) {
    return (
      <div>
        <ListItem
          to={link}
          disabled={true}
          component={NavLink}
          onClick={() => props.updateRedirect({id: value})}
          classes={{ root: 'attributes', disabled: 'opaque' }}
        >
          <ListItemText primary={label} secondary={value || '-'} className={'listItem-secondary-color'} style={{color: 'rgba(0, 0, 0, 0.87)'}} />
        </ListItem>
        <Divider />
      </div>
    );
  }

  function rowForPrimaryVCams() {
    const dateTimeFormat = 'YYYY-MM-DD HH:mm';
    const upTime = info.uptime ? moment.unix(info.uptime).format(dateTimeFormat) : '-';
    const heartBeat = props.heartbeat ? moment(props.heartbeat).format(dateTimeFormat) : '-';
    return (
      <List className="list-horizontal-flex">
        {staticText('EWC Name', props.ewc_instance_name)}
        {staticText('UUID', props.uuid)}
        {staticText('MAC', props.mac)}
        {staticText('IP Address', props.serverIP)}
        {staticText('Publisher Port', props.publish_port)}
        {props.multicast_ip ? staticText('Multicast IP', props.multicast_ip) : null}
        {props.multicast_port ? staticText('Multicast Port', props.multicast_port) : null}
        {staticText('User Name', props.userName)}
        {staticText('Password', props.password)}
        {staticText('Up Time', upTime)}
        {staticText('Last Heartbeat', heartBeat)}
        {getLinkStaticText('Camera UUID', props.pcam_uuid, '/cameras')}
        {getLinkStaticText('Device UUID', props.device_uuid, '/devices')}
        {displayProfile()}
        {staticText('Bitrate', props.info.bitrate)}
        {staticText('Onvif Url', props.onvifUrl, 'copy')}
        {staticText('Rtsp Url', props.RtspUrl, 'copy')}
        {staticText('Clients', clients.length, 'info', props.onClientInfo)}
        {staticText('Restart Count', restartCount)}
        {staticText('Error State', error.state)}
        {staticText('Error Message', error.msg)}
      </List>
    );
  }

  function rowForSecondaryVCams() {
    return (
      <List className="list-horizontal-flex">
        {staticText('EWC Instance Id', props.ewc_instance_id)}
        {staticText('UUID', props.uuid)}
        {getLinkStaticText('Primary Virtual Camera UUID', props.primary_vcam_uuid, '/vcam')}
        {staticText('Status', props.status)}
        {staticText('State', props.state)}
        {staticText('User Name', props.userName)}
        {staticText('Password', props.password)}
        {staticText('Rtsp Url', props.RtspUrl)}
        {staticText('Rtsp Port', props.rtspPort)}
        {staticText('Message', props.msg)}
      </List>
    );
  }

  function row1 () {
    return (
      <>
        {isPrimary ? rowForPrimaryVCams() : rowForSecondaryVCams()}
        <Grid container>
          {!isViewerUser() ? r1Action() : null }
        </Grid>
      </>
    );
  }

  function row2() {
    const postProcesses = props.post_processes;
    const postProcess = postProcesses !== undefined && postProcesses !== null && postProcesses.length > 0
      ? props.post_processes[0]
      : undefined;
    const multicastIp = postProcess?.dst_multicast_ip;
    const multicastPort = postProcess?.dst_multicast_port;
    const status = postProcess?.status;
    const errorMsg = postProcess?.error?.msg;
    const streamingUrl = multicastIp && multicastPort ? `udp://${multicastIp}:${multicastPort}` : '-';
    const sourceMulticastIp = postProcess?.src_multicast_ip;
    const created_at = postProcess?.created_at;
    const updated_at = postProcess?.updated_at;
    const isRestartPPDisabled = () => multicastIp === undefined || multicastIp === null || multicastIp === '';
    return (
      <>
        <h4 className="margin-bottom-none" style={{marginTop: 0}}>
          Post-processing Information
        </h4>
        <List className="list-horizontal-flex">
          {staticText('Dst. Multicast IP Address', multicastIp)}
          {staticText('Dst. Multicast Port', multicastPort)}
          {staticText('Post-processing Status', status)}
          {staticText('Error Message', errorMsg)}
          {staticText('Streaming URL', streamingUrl, 'copy')}
          {staticText('Src. Multicast IP Address', sourceMulticastIp)}
          {staticText('Created At', created_at)}
          {staticText('Updated At', updated_at)}
        </List>
        <Grid container>
          <Grid item xs={12}>
            <Box display='flex' justifyContent='flex-end' alignItems='center'>
              <Box>
                <Button variant='contained' color='primary' onClick={restartPP} disabled={isRestartPPDisabled()}>
                  Restart PP
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  }

  function restartPP() {
    AppActions.restartPP(props.uuid, props.type)
      .then(() => AppActions.setSnackbar('Successful restart'))
      .catch(error => showError(error, `failed to restart`))
  }

  return (
    <>
      <div className='infrastructure-expanded'>
        <div className='border'>{row1()}</div>
        {
          isPrimary ? (<div className='border' style={{marginTop: 15}}>{row2()}</div>) : null
        }
      </div>
    </>
  );
}

VcamsExpanded.propTypes = {
  mac: PropTypes.string,
  ewc_instance_name: PropTypes.string,
  uuid: PropTypes.string,
  userName: PropTypes.string,
  password: PropTypes.string,
  serverIP: PropTypes.string,
  privateIP: PropTypes.string,
  info: PropTypes.object,
  onvifUrl: PropTypes.onvifUrl,
  RtspUrl: PropTypes.RtspUrl,
  error: PropTypes.error,
  infraList: PropTypes.array,
  onDeploy: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChangeType: PropTypes.func.isRequired,
  onRestart: PropTypes.func.isRequired,
  onClientInfo: PropTypes.func.isRequired
};

export default React.memo(VcamsExpanded);
